export enum BidPackagePublishStep {
  SELECT_TRADES = "selectTrades",
  UPDATE_BID_INFO = "updateBidInfo",
  ADD_INVITATION_TEXT = "addInvitationText",
  REVIEW_AND_PUBLISH = "reviewAndPublish",
}
